import React, { useState } from "react";
/* Bootstrap Components */
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Tabs, Tab } from "react-bootstrap-tabs";

import { StyledWrapperAgenda } from "./styled";
import { BiCalendarCheck } from "react-icons/bi";
function Agenda(props) {
  const [showUno, setShowUno] = useState(true);
  const [showDos, setShowDos] = useState(false);
  const [id, setid] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [focusProject, setFocusProject] = useState(null);

  const handleShow = (item) => {
    console.log("ENTRAR", item);
    setModalIsOpen(true);
    setFocusProject(item);
  };


  return (
    <Row id="agenda">
      <StyledWrapperAgenda>
        <Row>
          <Col xs={12} sm={12} md={4} lg={3} xl="2">
            <h1>SCHEDULE</h1>
            <hr />
          </Col>
        </Row>
        <Row style={{ marginTop: "60px" }}>
          <Col lg={10} className="mx-auto">
            <Tabs
              headerStyle={{ fontWeight: "bold" }}
              activeHeaderStyle={{ color: "#E63457" }}
              contentStyle={{
                backgroundColor: "#EDEDED",
                paddingBottom: "60px",
              }}
              style={{ paddingBottom: "60px", marginBottom: "40px" }}
            >
              <Tab label="Day 1">
                <Row>
                  <Col
                    lg={2}
                    style={{
                      marginTop: "60px",
                      borderRight: "1px solid #354052",
                    }}
                  >
                    <Row>
                      <Col
                        lg={12}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <BiCalendarCheck
                          style={{ color: "#E63457" }}
                          size={60}
                        />
                        <p
                          style={{
                            fontSize: "20px",
                            lineHeight: "24px",
                            textAlign: "center",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: "#E63457",
                          }}
                        >
                          thursday 06-10
                        </p>
                        <p
                          style={{
                            fontSize: "20px",
                            lineHeight: "24px",
                            textAlign: "center",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: "#E63457",
                            marginTop: "20px"
                          }}
                        >
                          Auditorium <br /> Santiago Páramo
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={10}
                    style={{
                      marginTop: "60px",
                    }}
                  >
                    <ul style={{ paddingRight: "2rem", paddingLeft: "2rem" }}>
                      {props.data
                        ?.filter((i) => i.dia === "1")
                        .map((el, id) => (
                          <li
                            onClick={() => handleShow(el)}
                            style={{ cursor: "pointer", 
                            lineHeight: "23px"
                        }}
                          >
                            <b style={{color: "#E63457"}}>{el.hora} - {el.titulo_agenda_en} </b>
                            <p style={{marginTop: "5px"}}>{el.descripcion_en}</p>
                          </li>
                        ))}
                    </ul>
                  </Col>
                  {/* <Col lg={5} style={{ marginTop: "60px" }}>
                    {focusProject && focusProject.ID ? (
                      <p style={{ paddingLeft: "2rem", paddingRight: "2rem" }}>
                        {focusProject.descripcion}
                      </p>
                    ) : null}
                  </Col> */}
                </Row>
              </Tab>
              <Tab label="Day 2">
                <Row>
                  <Col
                    lg={2}
                    style={{
                      marginTop: "60px",
                      borderRight: "1px solid #354052",
                    }}
                  >
                    <Row>
                      <Col
                        lg={12}
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <BiCalendarCheck
                          style={{ color: "#E63457" }}
                          size={60}
                        />
                        <p
                          style={{
                            fontSize: "20px",
                            lineHeight: "24px",
                            textAlign: "center",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: "#E63457",
                          }}
                        >
                          friday 07-10
                        </p>
                        <p
                          style={{
                            fontSize: "20px",
                            lineHeight: "24px",
                            textAlign: "center",
                            marginBottom: "0px",
                            fontWeight: "bold",
                            color: "#E63457",
                            marginTop: "20px"
                          }}
                        >
                          Auditorium <br /> Marino Troncoso
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    lg={10}
                    style={{
                      marginTop: "60px"
                    }}
                  >
                    <ul style={{ paddingRight: "2rem", paddingLeft: "2rem" }}>
                    {props.data
                        ?.filter((i) => i.dia === "2")
                        .map((el, id) => (
                          <li
                            onClick={() => handleShow(el)}
                            style={{ cursor: "pointer", 
                            lineHeight: "25px"
                        }}
                          >
                            <b style={{color: "#E63457"}}>{el.hora} - {el.titulo_agenda_en} </b>
                            <p style={{marginTop: "5px"}}>{el.descripcion_en}</p>
                          </li>
                        ))}
                    </ul>
                  </Col>
                  {/* <Col lg={5} style={{ marginTop: "60px" }}>
                    {focusProject && focusProject.ID ? (
                      <p style={{ paddingLeft: "2rem", paddingRight: "2rem" }}>
                        {focusProject.descripcion}
                      </p>
                    ) : null}
                  </Col> */}
                </Row>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </StyledWrapperAgenda>
    </Row>
  );
}

export default Agenda;
